export default {"src":"/_next/static/media/illustration-chop.5a84043d.svg","height":120,"width":120};